var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 12C85.755 12 79.695 17.1625 78.3025 24H66V30H78.3025C79.695 36.8375 85.7575 42 93 42C101.27 42 108 35.27 108 27C108 18.73 101.27 12 93 12ZM93 36C88.0375 36 84 31.9625 84 27C84 22.0375 88.0375 18 93 18C97.9625 18 102 22.0375 102 27C102 31.9625 97.9625 36 93 36Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 87C40.71 87 36 91.71 36 97.5C36 103.29 40.71 108 46.5 108C51.78 108 56.16 104.082 56.89 99H66.425V93H55.9825C54.295 89.455 50.6775 87 46.4975 87H46.5ZM46.5 102C44.0175 102 42 99.9825 42 97.5C42 95.0175 44.0175 93 46.5 93C48.9825 93 51 95.0175 51 97.5C51 99.9825 48.9825 102 46.5 102Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 41.46L12.5875 40.05C12.1975 41.6625 12 43.3275 12 45C12 49.22 13.2475 53.2925 15.6075 56.7725L20.5725 53.405C18.8875 50.92 17.9975 48.015 17.9975 45C17.9975 43.8025 18.1375 42.6125 18.4175 41.46H18.42Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93H75.4275V99H78C82.8725 99 87.62 97.2925 91.37 94.195L87.5475 89.57C84.87 91.7825 81.48 93 78 93Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 24H42V30H57V24Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24C27.0975 24 21.435 26.505 17.4625 30.8725L21.9 34.91C24.7375 31.79 28.785 30 33 30V24Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4275 60H48.4275V66H63.4275V60Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.985 67.08L88.48 61.6225C86.125 60.545 83.6075 59.9975 81 59.9975H72.4275V65.9975H81C82.74 65.9975 84.4175 66.36 85.985 67.0775V67.08Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.28 71.805C92.405 73.6675 93 75.81 93 78C93 79.9275 92.64 81.805 91.93 83.5775L97.5 85.81C98.495 83.325 99 80.6975 99 78.0025C99 74.7175 98.105 71.5025 96.415 68.705L91.28 71.8075V71.805Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33 60C30.575 60 28.2625 59.44 26.1275 58.3375L23.375 63.6675C26.3275 65.1925 29.6575 66 33.0025 66H39.43V60H33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.f16c4fe9.svg";
export { ForwardRef as ReactComponent };